import { Component, ViewChild, HostBinding, Input, ElementRef, Renderer2 } from '@angular/core';
import { UpgradeService } from './upgrade.service';
import ArrayStore from 'devextreme/data/array_store';
import { __i18n, LocalisationService } from '@localisation';

@Component({
    selector: 'parameter-window',
    templateUrl: './parameter-window.template.html',
    standalone: false
})
export class ParameterWindowComponent {
    constructor(
        public localisation: LocalisationService
    ){}

    @ViewChild('slider', { static : false})
    public slider: any;

    @ViewChild('upgradeGrid', { static : false})
    public upgradeGrid: any;

    @ViewChild('plantGrid', { static : false})
    public plantGrid: any;

    @ViewChild('applicationSetGrid', { static : false})
    public applicationSetGrid: any;

    @ViewChild('backupPersistentGrid', { static : false})
    public backupPersistentGrid: any;

    @ViewChild('backupGrid', { static : false})
    public backupGrid: any;

    @Input()
    public selector: any;

    public innerData: any;

    @Input()
    public addCurrentEntry: boolean = false;

    @Input()
    public set data(data: any){
        if(JSON.stringify(data) === JSON.stringify(this.innerData)){
            return;
        }
        this.innerData = data;
        this.plantData =  new ArrayStore({
            key: 'SiteFileId',
            data: (data?.parameterFileNames?.length)
                ? data.parameterFileNames.filter((current) => !current.IsDeviceUpload) :  []
        });

        this.upgradeData =  new ArrayStore({
            key: 'SiteFileId',
            data: (() => {
                const entries = (data?.parameterFileNames?.length)
                    ? data.parameterFileNames.filter((current) => current.IsDeviceUpload) : [];
                if(this.addCurrentEntry){
                    entries.unshift({
                        SiteFileId: null,
                        FileName : __i18n('<use current>', 'upgrade.use-current.text')
                    });
                }
                return entries;
            })()
        });


        this.applicationData = new ArrayStore({
            key: 'id',
            data: (data.applicationSetParameterFile) ? [data.applicationSetParameterFile] : null
        });
        this.selectRows();
    }

    public get data(){
        return this.innerData;
    }

    public selectedRowKeys: any;

    public selectionFilter: any;

    public plantData: any;

    public upgradeData: any;

    public applicationData: any;

    public selectedEntry: any;

    public selectEntry(e){
        this.selectedEntry = e.data;
        if(this.innerData.parameterFileUuid === e.data.id || this.innerData.parameterFileUuid.SiteFileId){
            this.selector.selectEntry(__i18n('<use application set>', 'upgrade.use-application-set.text'));
        }else{
            this.selector.selectEntry(e.data.FileName || e.data.fileName);
        }
    }

    public deSelectEntries(selected){
        for(const grid of this.grids){
            grid.grid.deselectAll();
        }
    }

    private selectUuid() {
        this.plantGrid.selectRows([this.innerData.parameterFileUuid]);
        this.upgradeGrid.selectRows([this.innerData.parameterFileUuid]);
        if(this.innerData.applicationSetParameterFile) {
            this.applicationSetGrid.selectRows([this.innerData.parameterFileUuid]);
        }
        this.selector.selectEntry(__i18n('<use application set>', 'upgrade.use-application-set.text'));
        this.selectedEntry = {
            SiteFileId : this.innerData.parameterFileUuid
           // Version : this.innerData.
        };
    }

    private selectParameterFileNames() {
        if(this.innerData.parameterFileNames.length){
            this.plantGrid.selectRows([this.innerData.parameterFileNames[0].SiteFileId]);
            this.upgradeGrid.selectRows([this.innerData.parameterFileNames[0].SiteFileId]);
            this.selector.selectEntry(this.innerData.parameterFileNames[0].FileName);
            this.selectedEntry = this.innerData.parameterFileNames[0];
        }
    }


    public selectRows(){
        if(this.addCurrentEntry){
            //this.upgradeGrid.selectRows(['--00--']);
            this.selector.selectEntry(__i18n('<use current>', 'upgrade.use-current.text'));
            this.selectedEntry = null;
        }else{
            if(this.upgradeGrid){
                if(this.innerData.parameterFileUuid){
                    this.selectUuid();
                }else{
                    this.selectParameterFileNames();
                }
                this.slideToSelected();
            }
        }
    }

    private selectSelected(){
        if(!this.selectedEntry){
            return;
        }
        for(const grid of this.grids){
            if(this.selectedEntry.SiteFileId) {
                grid.grid.selectRows([this.selectedEntry.SiteFileId]);
            }else if(this.selectedEntry.id){
                grid.grid.selectRows([this.selectedEntry.id]);
            }else{
                grid.grid.deselectAll();
            }
        }
    }

    public slideToSelected() {
        this.selectSelected();
        if(this.selectedEntry) {
            for(const grid of this.grids){
                if(grid.instance.getSelectedRowsData().find((current) => {
                    const result = this.selectedEntry
                        && (
                            this.selectedEntry.SiteFileId && (this.selectedEntry.SiteFileId === current.SiteFileId)
                            || this.selectedEntry.SiteFileId && (this.selectedEntry.SiteFileId === current.id)
                            || this.selectedEntry.id && (this.selectedEntry.id === current.id)
                            || this.selectedEntry.id && (this.selectedEntry.id === current.SiteFileId)
                        );
                    return result;
                })){
                    this.slider.slideToName(grid.name);
                }else{
                    grid.grid.deselectAll();
                }
            }
        }
    }

    public getSelectedEntry(){
        return this.selectedEntry;
    }

    public grids: any[] = [];

    public ngAfterViewInit(){

        setTimeout(() => {
            this.grids.push({
                name : 'upgrade',
                instance : this.upgradeGrid.dxDataGrid.instance,
                grid : this.upgradeGrid
            });
            this.grids.push({
                name : 'plant',
                instance : this.plantGrid.dxDataGrid.instance,
                grid : this.plantGrid
            });
            this.grids.push({
                name : 'application-set',
                instance : this.applicationSetGrid.dxDataGrid.instance,
                grid : this.applicationSetGrid
            });
            this.grids.push({
                name : 'backup-persistent',
                instance : this.backupPersistentGrid.dxDataGrid.instance,
                grid : this.backupPersistentGrid
            });
            this.grids.push({
                name : 'backup',
                instance : this.backupGrid.dxDataGrid.instance,
                grid : this.backupGrid
            });
            this.selectRows();
            this.selector.onOpen.subscribe(() => {
                setTimeout(() => this.slideToSelected(), 100);
            });
        });
    }
}
